import React, { useState, useRef, useEffect, useCallback } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
  MenuItem,
  TextField,
  Menu,
  Dialog,
  Box,
  Tooltip,
  Popover,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import {
  MdAddCircleOutline,
  // ... your other icons like MdDashboard, MdSettings, etc.
} from "react-icons/md";
import axios from "axios";
import { GiSpades } from "react-icons/gi";

import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import NotificationsIcon from "@mui/icons-material/Notifications";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import Pagination from "./Pagination";
import SortableButton from "./SortableButton";
import DropdownCell from "./DropdownCell"; // Import DropdownCell
import { saveData, deleteData } from "./api";
import ListCell from "./ListCell";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TableExporterImporter from "./TableExporterImporter";
import DateCell from "./DateCell";
import FileUploaderCell from "../components/FileUploaderCell";
import subscriptionStatus from "../components/SubscriptionStatus";
import { useTheme } from "../context/ThemeContext";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ShowDetails from "../components/ShowDetails";
import Invoice from "../components/Invoice";
import EmailIcon from "@mui/icons-material/Email"; // Import Email icon
import AdvertiserButton from "../components/AdvertiserButton";
import Sidebar from "./Sidebar";
import config from "../config";

const baseUrl = config.baseURL;
import { useMediaQuery } from "@mui/material";
const DataTable = ({
  title,
  columns,
  data,
  setData,
  onAddRow,
  onSort,
  filters = {},
  onFilterChange,
  sortField,
  sortOrder,
  actions,
  currentPage,
  totalPages,
  onPageChange,
  apiEndpoint,
  itemsPerPage,
  fetchData,
  getRangeInputProps,
  showAddButton = true,
  allData,
  totalItems,
  selectedItems,
  ExpesnesDate,
  ExpesnesAmount,
  bottomNavHeight,
}) => {
  console.log(
    "cyyreent page",
    //     "DataTable",
    //     title,
    //     columns,
    data,
    allData,
    //     setData,
    //     onAddRow,
    //     onSort,
    //     filters,
    //     sortField,
    //     sortOrder,
    //     actions,
    currentPage
    //     totalPages,
    //     onPageChange,
    //     apiEndpoint
  );
  // console.log("datetable ExpesnesAmount", ExpesnesAmount);
  // console.log(" datetable ExpesnesDate", ExpesnesDate);
  // console.log(" selectedItems data", selectedItems);
  // console.log(" selectedItems actions", actions);
  const [editingCell, setEditingCell] = useState(null);
  const [editingValue, setEditingValue] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const paginationRef = useRef(null);
  const isSubscribed = subscriptionStatus();
  const [openText, setOpenText] = useState(false);
  const [fullText, setFullText] = useState("");
  const { theme } = useTheme();
  const [filterValues, setFilterValues] = useState(filters);
  const [userData, setUserData] = useState(null);
  const backgroundColor = isSubscribed
    ? theme.background
    : process.env.REACT_APP_BACKGROUND;
  const isMobile = useMediaQuery("(max-width:768px)");
  const isSmallMobile = useMediaQuery("(max-width:480px)");
  const textColor = isSubscribed ? theme.text : process.env.REACT_APP_TEXT;

  const tableColor = isSubscribed ? theme.table : process.env.REACT_APP_TABLE;
  const isLongText = (text) => text && text.length > 80;
  const handleDoubleClick = (value, rowId, colAccessor) => {
    setEditingCell({ rowId, colAccessor });
    setEditingValue(value || "");
  };
  const EnterpriseColors = {
    SidebarBg: "#1F2937", // Dark Slate/Almost Black
    PrimaryText: "#F9FAFB", // Light Gray/White
    SecondaryText: "#9CA3AF", // Medium Gray
    HoverBg: "#374151", // Slightly Lighter Dark Gray for hover
    ActiveBg: "#4B5563", // Darker Gray for active state
    Accent: "#4F46E5", // Indigo/Blue for primary actions
    IconDefault: "#D1D5DB", // Light Gray for icons
    IconHover: "#F9FAFB", // White for hovered icons
    // ✨ NEW: Light Gray for the Create New Module button
    NewModuleButtonBg: "#D1D5DB", // Light Gray
    NewModuleButtonText: "#1F2937", // Dark text for light button
    NewModuleButtonHover: "#E5E7EB", // Slightly lighter gray for hover

    MobileBarBg: "#1F2937", // Same as SidebarBg (Dark Slate/Almost Black)
    MobileIconActive: "#4F46E5", // Accent color (Indigo/Blue)
    MobileIconInactive: "#9CA3AF", // SecondaryText (Medium Gray)
  };
  console.log("data", data);
  useEffect(() => {
    const handleOnlineStatus = () => {
      setIsOffline(!navigator.onLine);
    };

    window.addEventListener("online", handleOnlineStatus);
    window.addEventListener("offline", handleOnlineStatus);

    return () => {
      window.removeEventListener("online", handleOnlineStatus);
      window.removeEventListener("offline", handleOnlineStatus);
    };
  }, []);
  useEffect(() => {
    // Dynamically set the position of the pagination
    if (paginationRef.current) {
      paginationRef.current.style.position = "fixed";
      paginationRef.current.style.bottom = `${bottomNavHeight + 10}px`; // Adjust distance from bottom nav
    }
  }, [bottomNavHeight]);
  // useEffect(() => {
  //   if (Object.keys(filterValues).length > 0) {
  //     fetchData(currentPage, itemsPerPage, filterValues);
  //     console.log("useeffect values ", currentPage, itemsPerPage, filterValues);
  //   }
  // }, [filterValues, currentPage, itemsPerPage]); // Run when filterValues or pagination changes
  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      console.log("No token found");
      return;
    }
    console.log("Using token:", token);
    const fetchUserData = async () => {
      try {
        const response = await fetch(`${baseUrl}/api/profile`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        // Check if the response is OK (status code 200-299)
        if (!response.ok) {
          const errorText = await response.text(); // Read the response body as text
          console.error("Error fetching user data:", errorText);
          throw new Error("Failed to fetch user data");
        }

        // Check if the response contains JSON
        const contentType = response.headers.get("Content-Type");
        if (!contentType || !contentType.includes("application/json")) {
          console.error("Expected JSON, but got:", contentType);
          throw new Error("Response is not JSON");
        }

        // Parse the JSON data if everything is okay
        const data = await response.json();
        setUserData(data); // Set user data to state
        console.log("User data:", data);
      } catch (error) {
        console.error("Error:", error.message);
      }
    };

    fetchUserData();
  }, []);
  // const handleBlur = async (rowId, colAccessor) => {
  //   const updatedData = {
  //     [colAccessor]: editingValue,
  //   };
  //   // console.log("handleBlur", rowId, colAccessor, updatedData);
  //   try {
  //     if (rowId) {
  //       await saveData(`${apiEndpoint}/${rowId}`, updatedData, "PUT");
  //     } else {
  //       const newRow = await saveData(apiEndpoint, updatedData, "POST");
  //       setData((prevData) =>
  //         prevData.map((row) => (row === editingCell ? { ...newRow } : row))
  //       );
  //     }

  //     setData((prevData) =>
  //       prevData.map((row) =>
  //         row.id === rowId ? { ...row, [colAccessor]: editingValue } : row
  //       )
  //     );
  //   } catch (error) {
  //     console.error(`Error saving data for ${colAccessor}:`, error);
  //   }

  //   setEditingCell(null);
  // };

  // const handleChange = useCallback((e) => {
  //   setEditingValue(e.target.value);
  //   console.log("e.target.value", e.target.value);
  // }, []);
  const handleChange = useCallback((e) => {
    setEditingValue(e.target.value);
    console.log("e.target.value", e.target.value);
  }, []);

  const handleBlur = useCallback(
    async (rowId, colAccessor) => {
      const updatedData = { [colAccessor]: editingValue };
      try {
        if (rowId) {
          await saveData(`${apiEndpoint}/${rowId}`, updatedData, "PUT");
        } else {
          const newRow = await saveData(apiEndpoint, updatedData, "POST");
          setData((prevData) =>
            prevData.map((row) => (row === editingCell ? { ...newRow } : row))
          );
        }
        setData((prevData) =>
          prevData.map((row) =>
            row.id === rowId ? { ...row, [colAccessor]: editingValue } : row
          )
        );
      } catch (error) {
        console.error(`Error saving data for ${colAccessor}:`, error);
      }
      setEditingCell(null);
    },
    [editingValue, editingCell, apiEndpoint, setData]
  );

  const handleDeleteRow = async (rowId) => {
    try {
      await deleteData(`${apiEndpoint}/${rowId}`);
      setData((prevData) => prevData.filter((row) => row.id !== rowId));
    } catch (error) {
      console.error("Error deleting row:", error);
    }
  };
  const handleDropChange = async (rowId, field, newValue) => {
    try {
      console.log("handleDropChange:", { rowId, field, newValue });

      // Prepare the updated data object
      const updatedData = {
        [field]: newValue, // Dynamically update the field
      };

      // Save the updated data to the backend
      await saveData(`${apiEndpoint}/${rowId}`, updatedData, "PUT");

      // Update the local state
      setData((prevData) =>
        prevData.map((data) =>
          data.id === rowId ? { ...data, [field]: newValue } : data
        )
      );

      // console.log(
      //   `Updated row ${rowId}, field ${field} with value: ${newValue}`
      // );
    } catch (error) {
      console.error(`Error updating row ${rowId}, field ${field}:`, error);
    }
  };
  const handleFilterMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleFilterMenuClose = () => {
    setAnchorEl(null); // Close the filter menu
    setFilterValues({}); // Reset filters to empty
    fetchData(1, itemsPerPage); // Re-fetch all data with default parameters
  };
  const handleFilterChange = (field, value) => {
    console.log("handleFilterChange ", field, value);
    setFilterValues((prevFilters) => ({
      ...prevFilters,
      [field]: value,
    }));
    // setTempValues((prev) => ({
    //   ...prev,
    //   [field]: value,
    // }));
  };
  const handleDateRangeChange = (start, end) => {
    // Update the filter values with the selected date range
    setFilterValues({
      ...filterValues,
      start_date: start, // Add start date to filterValues
      end_date: end, // Add end date to filterValues
    });

    // Re-fetch data with the updated filters
    fetchData(1, itemsPerPage, start, end);
  };
  const sendReplyEmail = async (rowId) => {
    try {
      // Dynamically find the row data based on the rowId (you can adjust this based on how you structure your data)
      const row = data.find((item) => item.id === rowId); // Assuming `data` is the array of rows

      if (!row) {
        toast.error("Row not found");
        return;
      }

      // Get the reply message dynamically from an input or modal (optional, can leave blank for user to fill out)
      const replyMessage = "Your reply message here"; // Customize this if needed, this could be pre-filled

      // Dynamically get the recipient's email (e.g., from the row data)
      const recipientEmail = row.email; // Make sure row has an email property

      if (!recipientEmail) {
        toast.error("Recipient email is missing");
        return;
      }

      // Dynamically create the subject (you can also make this dynamic if needed)
      const subject = encodeURIComponent(
        `Reply to Your Contact Form Submission: ${row.full_name}`
      );

      // Create the body of the email, dynamically adding the reply message
      const body = encodeURIComponent(
        `Hello ${row.full_name},\n\n${replyMessage}\n\nBest Regards,\nSpade`
      );

      // Create the mailto link
      const mailtoLink = `mailto:${recipientEmail}?subject=${subject}&body=${body}`;

      // Open the default email client with the prefilled information
      window.location.href = mailtoLink;

      // The user will now see the email client open, where they can freely modify and send the email
    } catch (error) {
      console.error("Error opening email client:", error);
      toast.error("Error opening the email client.");
    }
  };

  const applyFilters = () => {
    console.log("Applying filters:", filterValues);
    // setFilterValues(tempValues); // Update the actual filter values
    // onFilterChange(tempValues);
    // onFilterChange(filterValues); // Pass filters back to the parent
    // fetchData(currentPage, (itemsPerPage = 10), filterValues);
    fetchData(1, itemsPerPage, filterValues);
    // fetchData(currentPage, (itemsPerPage = 10), tempValues);
    setAnchorEl(null); // Close the filter menu
  };
  // const cancelFilter = () => {
  //   // setTempValues({});

  //   // setFilterValues({});
  //   // fetchData(currentPage, (itemsPerPage = 10), itemsPerPage);
  //   const filterValues = {};
  //   onFilterChange(filterValues); // Pass filters back to the parent
  //   fetchData(currentPage, (itemsPerPage = 10), filterValues);
  //   setAnchorEl(null);
  // };
  const cancelFilter = () => {
    setFilterValues({}); // Clear the filter state
    fetchData(currentPage, itemsPerPage, {}); // Fetch data without any filters
    setAnchorEl(null); // Close the filter menu
  };

  const handleSave = async (newValueId, rowId, fieldName) => {
    try {
      let newValueName = []; // Initialize as an array to hold multiple names
      // console.log("rowId", rowId);
      // console.log("fieldName", fieldName);
      // console.log("newValueId", newValueId);

      // Loop through columns to find the relevant options
      columns.map((col) => {
        // console.log("Column Header:", col.header);
        // console.log("Column Accessor:", col.accessor);
        // console.log("Column options:", col.options);

        if (col.accessor === fieldName) {
          col.options?.forEach((option) => {
            // Ensure newValueId is an array and compare option.id with newValueId
            if (newValueId.includes(option.id)) {
              // Use `includes` to check if the id is in newValueId
              newValueName.push(option.name || option.public_id); // Store the name if id matches
            }
            // console.log("Option ID:", option.id);
            // console.log("Option Name:", option.name);
            // console.log("Option public id:", option.public_id);
          });
        }
      });

      // console.log("newValueName after loop:", newValueName);

      // Prepare the updated data object with ids (newValueId)
      const updatedData = { [fieldName]: newValueId }; // Save the ids in the object
      // console.log("updatedData", updatedData);
      // console.log("newValueId", newValueId);
      // console.log("newValueName", newValueName);

      // If the row exists, perform an update (PUT request)
      if (rowId) {
        await saveData(`${apiEndpoint}/${rowId}`, updatedData, "PUT");

        // Update local state after saving data
        setData((prevData) =>
          prevData.map((row) =>
            row.id === rowId ? { ...row, [fieldName]: newValueName } : row
          )
        );
      } else {
        // If it's a new row, create it (POST request)
        const newRow = await saveData(apiEndpoint, updatedData, "POST");

        // Update local state with the newly created row
        setData((prevData) => [...prevData, { ...newRow }]);
      }
    } catch (error) {
      console.error(`Error saving ${fieldName}:`, error);
    }
  };
  const handleSaveFilter = (newSelectedItems, fieldName) => {
    console.log(`Saving filter for ${fieldName}:`, newSelectedItems);

    // Create an array to hold the names corresponding to the selected IDs
    let newValueNames = [];

    // Assuming you have a column object with options (where each option has id and name)
    columns.forEach((col) => {
      if (col.accessor === fieldName) {
        // Loop through options to get the name corresponding to each selected ID
        col.options?.forEach((option) => {
          if (newSelectedItems.includes(option.id)) {
            newValueNames.push(option.name || option.public_id); // Push the name or another field
          }
        });
      }
    });

    // Log the names to ensure they're correct
    console.log(`Selected names for ${fieldName}:`, newValueNames);

    // Update the filter values with the selected names instead of IDs
    setFilterValues((prevValues) => ({
      ...prevValues,
      [fieldName]: newValueNames, // Update the filter with the names
    }));

    // Optionally, you can pass the updated values to an API or a parent component
    console.log(`Saved filter for ${fieldName} with values:`, newValueNames);
  };
  const handleOpenText = (text) => {
    setFullText(text || "");
    setOpenText(true);
  };
  const assignDate = (rowId, date, fieldName) => {
    // Update the specific field in the row (e.g., 'production_date', 'expiry_date')
    setData((prevData) =>
      prevData.map((row) =>
        row.id === rowId ? { ...row, [fieldName]: date } : row
      )
    );

    // Format the date to ISO before saving
    // const formattedDate = formatDateToISO(date);
    const formattedDate = date;
    console.log("assignDate rowId ", rowId);

    // If the date is valid (i.e., formattedDate is not null), then save it
    if (formattedDate) {
      // console.log("formattedDate", formattedDate);
      handleSave(formattedDate, rowId, fieldName); // Save the formatted date
    } else {
      console.error("Invalid date format:", date); // Log if the date is invalid
    }
  };
  const getDetailsData = (row, field) => {
    let detailsDate = null;
    let detailsData = null;

    // console.log("row in getDetailsData", row);
    // console.log("Field being checked:", field); // Log the field to see which one is being passed

    // Check for specific field details based on the dynamic field name
    if (row[`${field}`]) {
      detailsDate = row[`${field}_details_date`]; // Dynamically access the field with '_date'
      detailsData = row[`${field}`]; // Dynamically access the field with '_data'
      // console.log(`${field} details`, detailsDate, detailsData);
    } else {
      detailsDate = "No Date Available"; // Fallback value
      detailsData = "No Data Available"; // Fallback value
    }

    return { detailsDate, detailsData };
  };

  const handleFileChange = async (file, rowId, col) => {
    try {
      const formData = new FormData();

      // لو عمود مختلف عن photo لازم تتعامل معه حسب اسمه
      // مثلاً لو اسم الحقل في الداتا بيز موجود في col.accessor
      formData.append(col.accessor, file);

      // const response = await axios.put(`${apiEndpoint}/${rowId}`, formData, {
      //   headers: {
      //     "Content-Type": "multipart/form-data",
      //   },
      // });
      console.log("formData", formData);

      const token = localStorage.getItem("token");
      const response = await axios.put(
        `${baseUrl}${apiEndpoint}/${rowId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (!response) {
        throw new Error("Failed to update file");
      }
      console.log("response", response);
      console.log("formData", formData);
      const updatedRow = response.data.data;

      setData((prevData) =>
        prevData.map((row) => (row.id === rowId ? updatedRow : row))
      );

      toast.success(`${col.accessor} updated successfully!`);
    } catch (error) {
      toast.error(`Error updating ${col.accessor}!`);
      console.error("Error updating file:", error.response || error.message);
    }
  };

  return (
    <div
      className="container mx-auto p-16 "
      style={{ backgroundColor: "#F4F6F9", minHeight: "100vh" }}
    >
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false} // Prevents sticking when switching tabs
        draggable
        pauseOnHover
      />

      {/* Header Section */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "16px",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontFamily: "Playfair Display",
            fontWeight: "bold",
          }}
          style={{ color: "#333333" }}
        >
          {title || "Data Table"}
        </Typography>
        <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
          {actions && actions.length > 0 && showAddButton && (
            <Button
              onClick={onAddRow}
              style={{
                backgroundColor: "transparent",
                color: "#2E4053",
              }}
              startIcon={<AddIcon />}
            />
          )}

          <Button
            onClick={handleFilterMenuOpen}
            style={{
              backgroundColor: "transparent",
              color: "#2E4053",
            }}
          >
            <FilterListIcon />
          </Button>
          <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleFilterMenuClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            PaperProps={{
              style: {
                padding: "25px", // Apply padding here
              },
            }}
          >
            {columns.map((col) => (
              <div key={col.accessor}>
                {col.type === "dropdown" ? (
                  // Render dropdown for 'dropdown' type filters
                  <TextField
                    select
                    label={col.header}
                    value={filterValues[col.accessor] || ""}
                    onChange={(e) =>
                      handleFilterChange(col.accessor, e.target.value)
                    }
                    fullWidth
                    style={{ margin: "5px" }}
                  >
                    {col.options.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : col.type === "range" ? (
                  // Render range inputs for 'range' type filters
                  <div style={{ display: "flex", gap: "10px" }}>
                    <TextField
                      label={`Min ${col.header}`}
                      inputProps={getRangeInputProps(col)} // Get range-specific props
                      type="number"
                      value={filterValues[`${col.accessor}_min`] || ""}
                      onChange={(e) =>
                        handleFilterChange(
                          `${col.accessor}_min`,
                          e.target.value
                        )
                      }
                      style={{ margin: "5px", width: "150px" }}
                    />
                    <TextField
                      label={`Max ${col.header}`}
                      inputProps={getRangeInputProps(col)} // Get range-specific props
                      type="number"
                      value={filterValues[`${col.accessor}_max`] || ""}
                      style={{ margin: "5px", width: "150px" }}
                      onChange={(e) =>
                        handleFilterChange(
                          `${col.accessor}_max`,
                          e.target.value
                        )
                      }
                    />
                  </div>
                ) : col.type === "showOnlyRange" ? (
                  <div style={{ display: "flex", gap: "10px" }}>
                    <TextField
                      label={`Min ${col.header}`}
                      inputProps={getRangeInputProps(col)} // Get range-specific props
                      type="number"
                      value={filterValues[`${col.accessor}_min`] || ""}
                      onChange={(e) =>
                        handleFilterChange(
                          `${col.accessor}_min`,
                          e.target.value
                        )
                      }
                      style={{ margin: "5px", width: "150px" }}
                    />
                    <TextField
                      label={`Max ${col.header}`}
                      inputProps={getRangeInputProps(col)} // Get range-specific props
                      type="number"
                      value={filterValues[`${col.accessor}_max`] || ""}
                      style={{ margin: "5px", width: "150px" }}
                      onChange={(e) =>
                        handleFilterChange(
                          `${col.accessor}_max`,
                          e.target.value
                        )
                      }
                    />
                  </div>
                ) : col.type === "file" ? null : col.type === "showOnly" ? (
                  // Render a read-only TextField for 'showOnly' type columns

                  <TableCell key={col.accessor} style={{ margin: "5px" }}>
                    <p style={{ fontSize: "15px", color: "#333333" }}>
                      {filterValues[col.accessor]
                        ? new Date(
                            filterValues[col.accessor]
                          ).toLocaleDateString()
                        : ""}{" "}
                      {/* Format and display the date */}
                    </p>
                  </TableCell>
                ) : col.type === "file" ? null : col.type === "showOnlyDate" ? (
                  // Render a read-only TextField for 'showOnly' type columns

                  <div>
                    <p style={{ fontSize: "8px" }}>{`Min ${col.header}`}</p>

                    <TextField
                      inputProps={getRangeInputProps(col)} // Get range-specific props
                      type="date"
                      value={filterValues[`${col.accessor}_start`] || ""}
                      onChange={(e) =>
                        handleFilterChange(
                          `${col.accessor}_start`,
                          e.target.value
                        )
                      }
                      style={{ margin: "5px" }}
                    />
                    <p style={{ fontSize: "8px" }}>{`Max ${col.header}`}</p>
                    <TextField
                      inputProps={getRangeInputProps(col)} // Get range-specific props
                      type="date"
                      value={filterValues[`${col.accessor}_end`] || ""}
                      style={{ margin: "5px" }}
                      onChange={(e) =>
                        handleFilterChange(
                          `${col.accessor}_end`,
                          e.target.value
                        )
                      }
                    />
                  </div>
                ) : col.type === "list" ? (
                  // Render range inputs for 'range' type filters

                  <div>
                    <p
                      style={{
                        fontSize: "10px",
                        margin: "5px",
                        padding: "10px",
                      }}
                    >{`${col.header}`}</p>

                    <ListCell
                      value={filterValues[col.accessor] || []} // Use col.accessor to access the filter value
                      options={col.options || []}
                      style={{ margin: "20px", padding: "10px" }}
                      onSave={(newSelectedItems) => {
                        console.log(
                          "filter list",
                          newSelectedItems, // Log the selected items
                          filterValues[col.accessor], // Current filter value
                          col.accessor
                        );

                        // Only save if there are selected items
                        if (newSelectedItems && newSelectedItems.length > 0) {
                          handleSaveFilter(newSelectedItems, col.accessor); // Save only if there are selected items
                        } else {
                          console.warn("No items selected!");
                        }
                      }}
                      onChange={(e) => {
                        console.log("Event object filter:", e);

                        // Check if e.target is defined and has the 'value' property
                        if (e && e.target && e.target.value) {
                          console.log("Target value:", e.target.value);
                          handleFilterChange(col.accessor, e.target.value); // Use col.accessor here
                        } else {
                          console.error(
                            "e.target is undefined or does not have a value property"
                          );
                        }
                      }}
                      valueName={col.header || "Select Items"}
                    />
                  </div>
                ) : col.type === "Date" ? (
                  <div>
                    <p style={{ fontSize: "8px" }}>{`Min ${col.header}`}</p>

                    <TextField
                      inputProps={getRangeInputProps(col)} // Get range-specific props
                      type="date"
                      value={filterValues[`${col.accessor}_start`] || ""}
                      onChange={(e) =>
                        handleFilterChange(
                          `${col.accessor}_start`,
                          e.target.value
                        )
                      }
                      style={{ margin: "5px" }}
                    />
                    <p style={{ fontSize: "8px" }}>{`Max ${col.header}`}</p>
                    <TextField
                      inputProps={getRangeInputProps(col)} // Get range-specific props
                      type="date"
                      value={filterValues[`${col.accessor}_end`] || ""}
                      style={{ margin: "5px" }}
                      onChange={(e) =>
                        handleFilterChange(
                          `${col.accessor}_end`,
                          e.target.value
                        )
                      }
                    />
                  </div>
                ) : col.type === "showOnlyText" ? (
                  // Render a read-only TextField for 'showOnly' type columns

                  <TextField
                    label={col.header}
                    value={filterValues[col.accessor] || ""}
                    onChange={(e) =>
                      handleFilterChange(col.accessor, e.target.value)
                    }
                    fullWidth
                    style={{ margin: "5px" }}
                  />
                ) : (
                  // Render a default text input for other types
                  <TextField
                    label={col.header}
                    value={filterValues[col.accessor] || ""}
                    onChange={(e) =>
                      handleFilterChange(col.accessor, e.target.value)
                    }
                    fullWidth
                    style={{ margin: "5px" }}
                  />
                )}
              </div>
            ))}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                onClick={applyFilters}
                sx={{
                  backgroundColor: "#2E4053",
                  color: "#FFFFFF",
                  margin: "5px",
                  marginTop: "10px",
                }}
              >
                Apply Filters
              </Button>
              <Button
                sx={{ backgroundColor: "#2E4053", color: "#FFFFFF" }}
                onClick={cancelFilter}
                style={{ marginLeft: "90px", marginTop: "10px" }}
              >
                Cancel
              </Button>
            </div>
          </Popover>
          <div>
            <TableExporterImporter
              data={allData}
              currentPageData={data}
              onDataChange={setData}
              Pagetitle={title}
            />
          </div>
        </div>
      </div>

      {/* Table Section */}
      <TableContainer
        component={Paper}
        style={{
          backgroundColor: "#D1D8E0",
          borderRadius: "10px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          overflowX: "auto",
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              {columns.map((col) => (
                <TableCell
                  key={col.accessor}
                  sx={{
                    fontWeight: "bold",
                    color: "#FFFFFF",

                    cursor: "pointer",
                    backgroundColor: "#2E4053",
                  }}
                >
                  <SortableButton
                    field={col.accessor}
                    label={col.header}
                    sortField={sortField}
                    sortOrder={sortOrder}
                    onSort={onSort}
                  />
                </TableCell>
              ))}
              {actions && (
                <TableCell
                  sx={{
                    // fontWeight: "bold",
                    color: "#FFFFFF",

                    cursor: "pointer",
                    backgroundColor: "#2E4053",
                  }}
                >
                  Actions
                </TableCell>
              )}
              {actions &&
                actions.some((action) => action.label === "Show Invoice") && (
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "#FFFFFF",

                      cursor: "pointer",
                      backgroundColor: "#2E4053",
                    }}
                  >
                    Invoice
                  </TableCell>
                )}
              {actions &&
                actions.some((action) => action.label === "Send Reply") && (
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "#FFFFFF",

                      cursor: "pointer",
                      backgroundColor: "#2E4053",
                    }}
                  >
                    Email
                  </TableCell>
                )}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={columns.length + (actions?.length || 0)}
                  sx={{
                    padding: "100px 20px",
                    backgroundColor: "#FDFDFD", // Clean, bright background
                    textAlign: "center",
                    borderBottom: "none",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      maxWidth: "600px",
                      margin: "0 auto",
                    }}
                  >
                    {/* 1. Icon Header */}
                    <Box
                      sx={{
                        width: "100px",
                        height: "100px",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "30px",
                        cursor: "pointer",

                        // ✅ Same color logic
                        backgroundColor: "#FBEFE0",
                        color: "#FFFFFF",

                        transition: "all 0.2s ease",

                        "&:hover": {
                          backgroundColor: "#1C2A3D",
                        },
                      }}
                    >
                      <MdAddCircleOutline size={50} />
                    </Box>

                    {/* 2. Motivational Messaging */}
                    <Typography
                      variant="h4"
                      sx={{
                        fontWeight: 800,
                        color: "#111827",
                        mb: 2,
                        fontFamily: "'Inter', sans-serif",
                      }}
                    >
                      Build Your Empire 👑
                    </Typography>

                    <Typography
                      sx={{
                        color: "#6B7280",
                        fontSize: "18px",
                        lineHeight: 1.6,
                        mb: 4,
                      }}
                    >
                      This is where your <strong>{title}</strong> management
                      begins. By adding your first data entry, you unlock the
                      power to track
                      <strong> real-time earnings</strong> and gain the{" "}
                      <strong>visibility</strong>
                      needed to scale your business to the next level.
                    </Typography>

                    {/* 3. The "Coming Soon" Advertiser Integration */}
                    {/* Desktop only – Coming Soon Advertiser CTA */}
                    {!isMobile && (
                      <Box sx={{ mb: 4, width: "100%" }}>
                        <Tooltip
                          title="This feature is coming soon! Stay tuned."
                          arrow
                          placement="bottom"
                        >
                          {/* Wrapper is required for Tooltip on disabled Button */}
                          <Box sx={{ display: "inline-block", width: "100%" }}>
                            <Button
                              disabled
                              fullWidth
                              variant="contained"
                              startIcon={<GiSpades size={20} />}
                              sx={{
                                minWidth: "180px",
                                borderRadius: "8px",
                                padding: "12px 16px",
                                fontWeight: 600,
                                fontSize: "0.9rem",

                                backgroundColor: "#9CA3AF !important",
                                color: "#F3F4F6 !important",
                                cursor: "not-allowed",
                                boxShadow: "none",
                                opacity: 0.85,

                                "&.Mui-disabled": {
                                  backgroundColor: "#9CA3AF",
                                  color: "#D1D5DB",
                                },
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  lineHeight: 1.2,
                                }}
                              >
                                {userData?.role !== "advertiser"
                                  ? "Become an Advertiser"
                                  : "Manage Your Ads"}

                                <span
                                  style={{
                                    fontSize: "10px",
                                    opacity: 0.9,
                                    textTransform: "uppercase",
                                    marginTop: 2,
                                  }}
                                >
                                  Coming Soon
                                </span>
                              </Box>
                            </Button>
                          </Box>
                        </Tooltip>
                      </Box>
                    )}

                    {/* 4. Inspirational Footer */}
                    <Box
                      sx={{
                        padding: "15px 25px",
                        borderRadius: "12px",
                        backgroundColor: "#F3F4F6",
                        borderLeft: "5px solid #4F46E5",
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          fontStyle: "italic",
                          color: "#374151",
                          fontWeight: 500,
                        }}
                      >
                        "The best way to predict the future is to create it." —
                        Start by adding data today.
                      </Typography>
                    </Box>
                  </Box>
                </TableCell>
              </TableRow>
            ) : (
              data.map((row, index) => (
                <TableRow
                  key={row.id || row.tempId || index}
                  hover
                  style={{
                    backgroundColor: index % 2 === 0 ? "#FFFFFF" : "#F8F9FC", // Even row: white, Odd row: light grayish-blue
                  }}
                >
                  {columns.map((col) =>
                    col.type === "dropdown" ? ( // Render DropdownCell for dropdown columns
                      <TableCell key={col.accessor}>
                        <DropdownCell
                          key={col.accessor}
                          disabled={
                            typeof col.disabled === "function"
                              ? col.disabled(row) // if function, pass row
                              : col.disabled // or static boolean
                          }
                          value={row[col.accessor] ? row[col.accessor] : ""}
                          onChange={(rowId, field, newValue) => {
                            handleDropChange(rowId, field, newValue); // Handle dropdown change globally
                          }}
                          options={col.options || []}
                          rowId={row.id}
                          field={col.accessor}
                          style={{ width: "100px" }}
                        />
                      </TableCell>
                    ) : col.type === "showOnly" ? (
                      // Render a read-only TextField for 'showOnly' type columns

                      <TableCell key={col.accessor}>
                        <p
                          style={{
                            fontSize: "15px",
                            color: "#333333", // Dark text color for readability
                            backgroundColor: "#f1f1f1", // Light background to distinguish it
                            cursor: "not-allowed", // Makes it clear the cell is not editable
                          }}
                        >
                          {row[col.accessor]}
                        </p>
                      </TableCell>
                    ) : col.type === "list" ? ( // Render ListCell for "list" type columns
                      <TableCell key={col.accessor}>
                        <div key={col.accessor}>
                          <ListCell
                            value={row[col.accessor] || []} // Default to an empty array if no value
                            options={col.options || []}
                            onSave={
                              (newSelectedItems) =>
                                handleSave(
                                  newSelectedItems,
                                  row.id,
                                  col.accessor
                                ) // Handle save for list items
                            }
                            onChange={(newSelectedItems) => {
                              // console.log(
                              //   "Selected items changed:",
                              //   newSelectedItems
                              // ); // Optional, log the change
                            }}
                            valueName={col.header || "Select Items"} // Use column header as valueName
                            style={{ width: "100px" }}
                          />
                        </div>
                      </TableCell>
                    ) : col.type === "showOnlyDate" ? (
                      // Render a read-only TextField for 'showOnly' type columns

                      <TableCell key={col.accessor} style={{ margin: "5px" }}>
                        <p
                          style={{
                            fontSize: "15px",
                            color: "#333333", // Dark text color for readability
                            backgroundColor: "#f1f1f1", // Light background to distinguish it
                            cursor: "not-allowed",
                          }}
                        >
                          {row[col.accessor]
                            ? new Date(row[col.accessor]).toLocaleDateString()
                            : ""}{" "}
                          {/* Format and display the date */}
                        </p>
                      </TableCell>
                    ) : col.type === "Date" ? ( // Render ListCell for "list" type columns
                      <TableCell key={col.accessor}>
                        {" "}
                        <div key={col.accessor}>
                          <DateCell
                            value={row[col.accessor] || []} // Default to an empty array if no value
                            onChange={assignDate} // Pass the change handler
                            rowId={row.id}
                            field={col.accessor || "Select Items"}
                            style={{ width: "100px" }}
                          />
                        </div>
                      </TableCell>
                    ) : col.type === "file" ? (
                      // Render a photo or file for 'file' type columns
                      <FileUploaderCell
                        key={col.accessor}
                        row={row} // تمرير row كامل
                        col={col} // تمرير col كامل
                        onFileChange={(file, id) =>
                          handleFileChange(file, id, col)
                        }
                      />
                    ) : col.type === "showOnlyRange" ? (
                      // Render read-only range for 'showOnlyRange' type columns
                      <TableCell key={col.accessor} style={{ margin: "5px" }}>
                        <p
                          style={{
                            fontSize: "15px",
                            color: "#333333", // Dark text color for readability
                            backgroundColor: "#f1f1f1", // Light background to distinguish it
                            cursor: "not-allowed",
                          }}
                        >
                          {row[col.accessor] ? row[col.accessor] : ""}{" "}
                          {/* Format and display the date */}
                        </p>
                      </TableCell>
                    ) : col.type === "TextDetails" ? (
                      <TableCell key={col.accessor}>
                        {" "}
                        <div key={row.id}>
                          {/* {console.log(
                          `88Field: ${col.accessor}, Date:`,
                          getDetailsData(row, col.accessor).detailsDate,
                          `Data:`,
                          getDetailsData(row, col.accessor).detailsData
                        )} */}

                          <ShowDetails
                            value={row[col.accessor] || []} // Default to an empty array if no value
                            onChange={handleDateRangeChange} // Pass the change handler
                            rowId={row.id}
                            field={col.accessor || "Select Items"}
                            style={{ width: "100px" }}
                            row={row}
                            data={getDetailsData(row, col.accessor).detailsData}
                            date={getDetailsData(row, col.accessor).detailsDate}
                          />
                        </div>
                      </TableCell>
                    ) : col.type === "showOnlyText" ? (
                      // Render a read-only TextField for 'showOnly' type columns

                      <TableCell
                        key={col.accessor}
                        style={{
                          cursor: "not-allowed",
                        }}
                      >
                        <p
                          style={{
                            width: "100%",
                            border: "none",
                            padding: "4px",
                            fontSize: "15px",
                            color: "#333333", // Dark text color for readability
                            backgroundColor: "#f1f1f1", // Light background to distinguish it
                            cursor: "not-allowed",
                          }}
                        >
                          {row[col.accessor]}
                        </p>
                      </TableCell>
                    ) : col.type === "icon" ? (
                      <TableCell key={col.accessor}>
                        {(() => {
                          let IconComponent;
                          switch (col.icon) {
                            case "email":
                              IconComponent = EmailIcon;
                              break;
                            case "whatsapp":
                              IconComponent = WhatsAppIcon;
                              break;
                            case "notification":
                              IconComponent = NotificationsIcon;
                              break;
                            default:
                              IconComponent = null;
                          }
                          return IconComponent ? (
                            <IconComponent
                              style={{
                                cursor: "pointer",
                                color:
                                  col.icon === "whatsapp" ? "green" : undefined,
                              }}
                              onClick={() => col.onClick && col.onClick(row)}
                            />
                          ) : null;
                        })()}
                      </TableCell>
                    ) : (
                      <TableCell
                        key={col.accessor}
                        onDoubleClick={() =>
                          handleDoubleClick(
                            row[col.accessor],
                            row.id,
                            col.accessor
                          )
                        }
                        style={{
                          backgroundColor:
                            editingCell?.rowId === row.id &&
                            editingCell?.colAccessor === col.accessor
                              ? "#2E4053"
                              : "transparent",
                        }}
                      >
                        {editingCell?.rowId === row.id &&
                        editingCell?.colAccessor === col.accessor ? (
                          <input
                            type="text"
                            value={editingValue || ""}
                            onBlur={() => handleBlur(row.id, col.accessor)}
                            onChange={handleChange}
                            autoFocus
                            style={{
                              width: "100%",
                              border: "none",
                              padding: "4px",
                              backgroundColor: "#2E4053",
                              color: "#FFFFFF",
                            }}
                          />
                        ) : (
                          row[col.accessor]
                        )}
                      </TableCell>
                    )
                  )}
                  {actions && actions.length > 0 && (
                    <TableCell>
                      <IconButton
                        onClick={() => handleDeleteRow(row.id)}
                        sx={{ color: "red" }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  )}
                  {actions &&
                    actions.some(
                      (action) => action.label === "Show Invoice"
                    ) && (
                      <TableCell>
                        <IconButton
                          onClick={() => setSelectedOrderId(row.id)} // Set order for invoice
                          sx={{ color: "#2E4053", marginLeft: "10px" }} // Add some spacing
                        >
                          <ReceiptIcon />
                        </IconButton>
                      </TableCell>
                    )}
                  {/* Email Action Button */}
                  {actions &&
                    actions.some((action) => action.label === "Send Reply") && ( // Check for the action label
                      <TableCell>
                        <IconButton
                          onClick={() => sendReplyEmail(row.id)} // Trigger the send email function
                          sx={{ color: "#2E4053", marginLeft: "10px" }} // Optional: Color and margin styling
                        >
                          <EmailIcon /> {/* Display email icon */}
                        </IconButton>
                      </TableCell>
                    )}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {selectedOrderId && (
        <Invoice
          orderId={selectedOrderId}
          onClose={() => setSelectedOrderId(null)}
        />
      )}

      <div
        // ref={paginationRef}
        style={{
          position: "fixed", // Fixed positioning ensures it stays in place
          bottom: isMobile ? "50px" : "20px", // Add some space from the bottom
          left: "50%", // Center the pagination horizontally
          transform: "translateX(-50%)", // Adjust position to perfectly center
          width: "auto", // Auto width for pagination container
          backgroundColor: "transparent", // Set a white background for visibility
          padding: "10px 20px", // Padding around the pagination for spacing
          // boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)", // Optional: subtle shadow
          zIndex: 1000, // Ensure it stays on top of other content
        }}
      >
        <div
          ref={paginationRef}
          style={{
            position: "fixed",
            bottom: isMobile ? "50px" : "20px",
            left: "50%",
            transform: "translateX(-50%)",
            padding: "10px 20px",
            backgroundColor: "transparent",
            zIndex: 1000,
          }}
        >
          <Pagination
            totalItem={data.length} // Total items for current page
            itemPerPage={itemsPerPage} // Items per page
            currentPage={currentPage} // Current page (1-based index)
            totalPages={totalPages} // Total number of pages
            onPageChange={(newPage) => {
              console.log("Page changed to:", newPage);
              onPageChange(newPage);
            }}
            fetchItems={(newPage) => fetchData(newPage, itemsPerPage)} // Function to fetch items
          />
          <div
            style={{
              padding: "15px",

              textAlign: "center",
              fontSize: "12px",
              color: EnterpriseColors.SecondaryText,

              flexShrink: 0, // Prevents footer from being squeezed
            }}
          >
            <span>&copy; Spade</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataTable;
